import API from 'services/API';

export default function deleteAccountAbroad(data) {
  return API.request({
    method: 'POST',
    url: '/foreignBankAccount/delete',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
